<div *ngIf="isLoaded">
    <div class="rejection-details" *ngIf="taskStatus && ['Rejected'].includes(taskStatus)">
        <app-rejection-details [supplierCode]='supplierCode'
            [rejectionDetails]='rejectionDetails'></app-rejection-details>
    </div>
    <div *ngIf="taskStatus && ['New', 'Rejected'].includes(taskStatus); else OtherContact">
        <tsl-alert *ngIf="contextVerbiage" icon="info_blue" style="color: #3E6AE1" status="primary">
            {{ translate.get(contextVerbiage?.domain?.description) }}
        </tsl-alert>
        <ng-container *ngIf="requestType">
            <ng-container *ngIf="['nameOrTINChange'].includes(requestType); else singleForm">
                <app-exist-select #selectTable
                    [columns]="displayedColumns"
                    [masterData]="tableData"
                    (onSelect)="onSelected($event)"
                    (onEdit)="onEdit($event)"
                    (onDelete)="onDelete($event)"
                    (onAdd)="onAdd($event)"
                ></app-exist-select>
              <p class="select-table-error-message" *ngIf="!isValidSelectTable">{{ this.translate.get(tableErrorMessage) }}</p>
            </ng-container>
            <ng-template #singleForm>
                <app-domain-edit 
                    #domainEdit [tsl-supplierCode]="supplierCode" [tsl-initialValue]="emailDomain"
                    [tsl-readOnly]="false" [tsl-hideSaveButton]="true" [tsl-domainDifferenceReasons]="domainDifferenceReasons$ | async"
                    (tsl-onSave)="emailDomainSubmit($event.emailDomain)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)"
                ></app-domain-edit>
            </ng-template>
        </ng-container>
    </div>
    <ng-template #OtherContact>
        <h3>
            <span i18n="@@taskCompleteRedirect" t="taskCompleteRedirect">
                Task is already completed please go back to home page.</span>
            <a i18n="@@clickHere" t="clickHere" href="javascript:void(0)" (click)="navigateToHome()">Click Here</a>
        </h3>
    </ng-template>
</div>